import { observer } from 'mobx-react'
import styles from './ExchangeCodeModal.module.less'
import { Input, Modal } from 'antd'
import { IconImage } from '../Icon'
import { useState } from 'react'
import classNames from 'classnames'
import { uiController } from '@/controllers/uiController'
import exchangeSuccess from '@/assets/images/bg_exchange_success.png'
import { api } from '@/helpers/api'
import { userService } from '@/services/userService'
export interface ExchangeCodeModalProps {
  visible: boolean
  onClose: () => void
}

const ExchangeCodeModal = observer(({ visible, onClose }: ExchangeCodeModalProps) => {
  const [code, setCode] = useState('')
  const [codeError, setCodeError] = useState('')

  const handleAddCode = async () => {
    if (code.length === 0) {
      return setCodeError('请输入兑换码')
    }

    setCodeError('')

    const res = await api.user.getExchangeCode(code).catch((err) => err)
    if (!res?.success) {
      return setCodeError(res.statusMessage)
    }

    await userService.getUserInfo()

    uiController.openExchangeSuccessModal(res.version)
    onClose()
  }

  return (
    <Modal
      open={visible}
      footer={null}
      closeIcon={false}
      onCancel={onClose}
      width={550}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: 8,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.exchangeCodeModal}>
        <div className={styles.modalClose} onClick={onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalTitle}>兑换码</div>
        <div className={styles.modalContent}>
          <div
            className={classNames(styles.codeInputBox, {
              [styles.error]: !!codeError,
            })}
          >
            <Input
              className={styles.codeInput}
              placeholder='请在此输入兑换码'
              value={code}
              allowClear
              onChange={(e) => setCode(e.target.value.trim())}
            />
            <div className={styles.codeInputError}>
              <span className={styles.codeInputErrorText}>* {codeError}</span>
            </div>
          </div>
          <div className={styles.btnBox}>
            <div className={styles.cancelBtn} onClick={onClose}>
              取消
            </div>
            <div className={styles.addBtn} onClick={handleAddCode}>
              兑换
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
})

export interface ExchangeSuccessModalProps {
  visible: boolean
  type: 'noce' | 'vip'
  onClose: () => void
}

export const ExchangeSuccessModal = observer(
  ({ visible, onClose, type }: ExchangeSuccessModalProps) => {
    return (
      <Modal
        open={visible}
        footer={null}
        closeIcon={false}
        onCancel={onClose}
        width={350}
        centered
        title={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: 8,
            overflow: 'hidden',
            backgroundColor: 'transparent',
          },
        }}
      >
        <div className={styles.exchangeSuccessModal}>
          <div className={styles.modalClose} onClick={onClose}>
            <IconImage width={16} className={styles.closeImg} src='IconClose' />
          </div>
          <div className={styles.modalTitle}>兑换成功</div>
          <div className={styles.modalContent}>
            <img draggable={false} alt='兑换成功' width={210.8} src={exchangeSuccess} />
            <div className={styles.modalContentText}>
              <p>恭喜你成功兑换</p>
              {type === 'noce' && <p>【任意模版1次下载机会】</p>}
              {type === 'vip' && <p>【1个月模板会员】</p>}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
)

export default ExchangeCodeModal
